<template>
  <section class="VideoBg">
    <video loop muted ref="video" class="video" v-if="!youtubeId">
      <source v-for="source in sources" :key="source" :src="source" :type="getMediaType(source)">
    </video>
    <youtube v-if="!!youtubeId" :player-vars="playerVars" class="video" :video-id="youtubeId" ref="video" @ended="playVideo"></youtube>
    <div class="VideoBg__content">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'videoBg',
  props: {
    sources: {
      type: Array
    },
    youtubeId: {
      default: '',
      type: String
    },
    img: {
      type: String
    }
  },
  data () {
    return {
      videoRatio: null,
      playerVars: {
        mute: 1,
        autoplay: 1,
        loop: 1,
        modestbranding: 0,
        playsinline: 1,
        origin: window.location.origin
        // volume: 0
      }
    }
  },
  mounted () {
    this.setImageUrl()
    this.setContainerHeight()
    if (this.youtubeId) {
      if (!this.$refs.video.player) return
      this.videoRatio = this.setContainerWidth() / this.setContainerHeight()
      this.setVideoSize()
      this.$refs.video.style.visibility = 'visible'
    } else if (this.videoCanPlay()) {
      this.$refs.video.oncanplay = () => {
        if (!this.$refs.video) return
        this.videoRatio = this.$refs.video.videoWidth / this.$refs.video.videoHeight
        this.setVideoSize()
        this.$refs.video.style.visibility = 'visible'
      }
    }
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize)
  },
  methods: {
    resize () {
      this.setContainerHeight()
      if (this.videoCanPlay()) {
        this.setVideoSize()
      }
    },
    videoCanPlay () {
      return !!this.$refs.video.canPlayType
    },
    setImageUrl () {
      if (this.img) {
        this.$el.style.backgroundImage = `url(${this.img})`
      }
    },
    playVideo () {
      this.$refs.video.player.playVideo()
    },
    setContainerHeight () {
      this.$el.style.height = `${window.innerHeight}px`
    },
    setContainerWidth () {
      this.$el.style.width = `${window.innerWidth}px`
    },
    setVideoSize () {
      var width; var height; var containerRatio = this.$el.offsetWidth / this.$el.offsetHeight
      if (containerRatio > this.videoRatio) {
        width = this.$el.offsetWidth
      } else {
        height = this.$el.offsetHeight
      }

      if (!this.youtubeId) {
        this.$refs.video.style.width = width ? `${width}px` : 'auto'
        this.$refs.video.style.height = height ? `${height}px` : 'auto'
      } else {
        let setPlayerWidth = this.$refs.video.player.setSize(
          width = this.setContainerHeight(),
          height = this.setContainerWidth()
        )
      }
    },
    getMediaType (src) {
      return 'video/' + src.split('.').pop()
    }
  }
}
</script>

<style>
  .VideoBg {
    position: relative;
    background-size: cover;
    background-position: center;
    overflow: hidden;
  }
  .VideoBg video {
    position: absolute;
    top: 50%;
    left: 50%;
    visibility: hidden;
    transform: translate(-50%, -50%);
  }
  .VideoBg iframe {
    padding: 0;
    margin: 0;
    width: 200%;
    height: 140%;

    position: relative;
    top: 75%;
    left: 75%;
    /* visibility: hidden; */
    transform: translate(-75%, -75%);
  }
  .VideoBg__content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
